function ScheduledIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="#4079F5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69063 16.0594C2.39688 15.7656 2.25 15.4125 2.25 15V4.5C2.25 4.0875 2.39688 3.73438 2.69063 3.44063C2.98438 3.14688 3.3375 3 3.75 3H4.5V1.5H6V3H12V1.5H13.5V3H14.25C14.6625 3 15.0156 3.14688 15.3094 3.44063C15.6031 3.73438 15.75 4.0875 15.75 4.5V9H14.25V7.5H3.75V15H9V16.5H3.75ZM14.25 18C13.3375 18 12.5406 17.7156 11.8594 17.1469C11.1781 16.5781 10.75 15.8625 10.575 15H11.7375C11.9 15.55 12.2094 16 12.6656 16.35C13.1219 16.7 13.65 16.875 14.25 16.875C14.975 16.875 15.5938 16.6188 16.1063 16.1063C16.6188 15.5938 16.875 14.975 16.875 14.25C16.875 13.525 16.6188 12.9062 16.1063 12.3938C15.5938 11.8813 14.975 11.625 14.25 11.625C13.8875 11.625 13.55 11.6906 13.2375 11.8219C12.925 11.9531 12.65 12.1375 12.4125 12.375H13.5V13.5H10.5V10.5H11.625V11.5688C11.9625 11.2438 12.3562 10.9844 12.8062 10.7906C13.2562 10.5969 13.7375 10.5 14.25 10.5C15.2875 10.5 16.1719 10.8656 16.9031 11.5969C17.6344 12.3281 18 13.2125 18 14.25C18 15.2875 17.6344 16.1719 16.9031 16.9031C16.1719 17.6344 15.2875 18 14.25 18Z" />
    </svg>
  )
}

export default ScheduledIcon
